/* eslint-disable no-param-reassign,no-console,no-underscore-dangle */
import axios from 'axios';
import router from '../router';
import store from '../store';
import Api from '../api';
import * as types from '../store/types';
import UI from './ui';

axios.defaults.timeout = 50000;
axios.defaults.baseURL = process.env.BASE_API;

let isRefreshing = false;
let subscribers = [];

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRrefreshed(token) {
  subscribers.map(cb => cb(token));
}

axios.interceptors.request.use(
  (config) => {
    store.commit(types.APP_UPDATE_LOAING_STATUS, { isLoading: true });
    if (store.getters.accessToken) {
      config.headers.authorization = store.getters.accessToken;
    }
    return config;
  },
  (error) => {
    console.log(error);
    store.commit(types.APP_UPDATE_LOAING_STATUS, { isLoading: false });
    Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    store.commit(types.APP_UPDATE_LOAING_STATUS, { isLoading: false });
    return response.data;
  },
  (error) => {
    console.log(error);
    store.commit(types.APP_UPDATE_LOAING_STATUS, { isLoading: false });
    if (!error.response) {
      UI.Toast.error('网络错误，请重试');
      return Promise.reject(error);
    }
    const { status, data } = error.response;
    if (status === 401 && data.code && data.code === 120001) {
      if (router.currentRoute.path !== '/binding') {
        router.replace({ path: 'binding' });
      }
    } else if (status === 401 && data.code && data.code === 141001) {
      const originalRequest = error.config;
      if (!isRefreshing) {
        isRefreshing = true;
        const refreshToken = store.getters.refreshToken;
        Api.login.refreshToken(refreshToken).then((res) => {
          store.commit(types.AUTH_LOGIN, {
            accessToken: res.token,
            refreshToken: res.refreshToken,
          });
          isRefreshing = false;
          onRrefreshed(res.token);
          subscribers = [];
        }).catch(() => {
          store.commit(types.AUTH_LOGOUT);
          UI.Alert.showAlert('', '您的登录信息已失效，请退出公众号后重新进入');
        });
      }
      return new Promise((resolve) => {
        subscribeTokenRefresh((token) => {
          originalRequest.headers.authorization = token;
          originalRequest.baseURL = '';
          resolve(axios(originalRequest));
        });
      });
    } else {
      // const code = data.code || 299999;
      const msg = '错误码：' + data.code + ', 错误信息：' + data.message;
      // if (code < 200000) {
      //   UI.Toast.warn(msg);
      // } else {
        UI.Toast.error(msg);
      // }
    }
    return Promise.reject(error);
  },
);

export default {
  get(url, params, responseType) {
    if (url.substring(0, 1) === '/') {
      axios.defaults.baseURL = process.env.BASE_API;
    } else {
      axios.defaults.baseURL = '';
    }
    return axios({
      method: 'get',
      url,
      params,
      responseType,
    });
  },

  post(url, data) {
    if (url.substring(0, 1) === '/') {
      axios.defaults.baseURL = process.env.BASE_API;
    } else {
      axios.defaults.baseURL = '';
    }
    return axios({
      method: 'post',
      url,
      data,
    });
  },

  post_openapi(url, data) {
    return axios({
      baseURL: process.env.BASE_URL_OPENAPI,
      method: 'post',
      url,
      data,
    });
  },

  delete(url, params) {
    if (url.substring(0, 1) === '/') {
      axios.defaults.baseURL = process.env.BASE_API;
    } else {
      axios.defaults.baseURL = '';
    }
    return axios({
      method: 'delete',
      url,
      params,
    });
  },

  put(url, data) {
    if (url.substring(0, 1) === '/') {
      axios.defaults.baseURL = process.env.BASE_API;
    } else {
      axios.defaults.baseURL = '';
    }
    return axios({
      method: 'put',
      url,
      data,
    });
  },
};



// WEBPACK FOOTER //
// ./src/utils/request.js